import { makeStyles } from '@mui/styles'

const useStyle = makeStyles(() => ({
  row: {
    width: '100%',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    background: '#f9f9f9',
    boxShadow: 'inset 0 -2px 0 #00a78f'
  },
  headCheck: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    height: 44,
    color: '#4B4952',
    width: '5%',
    top: 0,
    zIndex: 2
  },
  headStatus: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#4B4952',
    width: '10%',
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 2
  },
  headName: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#4B4952',
    width: '15%',
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 2
  },
  headCuit: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#4B4952',
    width: '5%',
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 2
  },
  headDate: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#4B4952',
    width: '25%',
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    '@media all and (max-width: 450px)': {
      display: 'none'
    }
  },
  numbersOfModules: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#4B4952',
    width: '20%',
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    '@media all and (max-width: 450px)': {
      display: 'none'
    }
  },
  numbersOfActiveUser: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#4B4952',
    width: '20%',
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    '@media all and (max-width: 450px)': {
      display: 'none'
    }
  },
  numbersOfDerivedUser: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#4B4952',
    width: '20%',
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    '@media all and (max-width: 450px)': {
      display: 'none'
    }
  },

  appCode: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#4B4952',
    width: '20%',
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    '@media all and (max-width: 450px)': {
      display: 'none'
    }
  },

  headKebab: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#4B4952',
    width: '5%',
    textAlign: 'start',
    position: 'sticky',
    top: 0,
    zIndex: 2
  }
}))

export default useStyle
